var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areaColumn chart__container"},[_c('h5',{staticClass:"f-title-7"},[_vm._v(_vm._s(_vm.scenario))]),_c('StagedChart',{attrs:{"stages":_vm.stages,"stage":_vm.scenarios.indexOf(_vm.scenario),"baseOptions":_vm.baseOptions,"updateArgs":[true, false, true]}}),_vm._t("legend")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }